module.exports = __webpack_public_path__ + "static/media/student_list.6e915569.svg";